export default "__VITE_ASSET__6a012695__"